export const STATISTICS_EXPORT_METRICS = [
  {
    key: "activeUsers",
    label: "Active users",
    defaultSelected: true,
  },
  {
    key: "totalUsers",
    label: "Total accounts",
    defaultSelected: true,
  },
  {
    key: "memberUsers",
    label: "Members",
    defaultSelected: true,
  },
  {
    key: "formsSubmitted",
    label: "Messages",
    defaultSelected: true,
  },
] as const;

export type StatisticsExportMetricKey =
  (typeof STATISTICS_EXPORT_METRICS)[number]["key"];
